import React, { useEffect, useState } from "react"
import {
  Button,
  Checkbox,
  Col,
  Input,
  InputNumber,
  Popconfirm,
  Radio,
  Row,
  Tag,
} from "antd"
import { isNumber } from "lodash"
import NumberFormat from "react-number-format"

const UpdateApproved = (props, params, value) => {
  props.onEngQuotaBurnApproved({
    id: params.id,
  })
}
export const renderApprovedButton = (params, { props }) => {
  return (
    <Popconfirm
      title="در صورت تایید این مبلغ از کارکرد کارشناس کم میشود"
      description="آیا مطمئن هستید!؟"
      onConfirm={() => UpdateApproved(props, params, !params.approved)}
      okText="Yes"
      cancelText="No"
    >
      <Checkbox checked={params.approved}></Checkbox>
    </Popconfirm>
  )
}

// ----------------------------------------------------------

const UpdateInline = (props, params, pNam, e) => {
  let getValue = e.target.value
  if (params[pNam] !== getValue) {
    props.onEngQuotaBurnUpdate({
      id: params.id,
      des: pNam === "des" ? getValue : params.des,
      amountBurning: params.amountBurning || 0,
    })
  }
}

const UpdateAmountInline = (props, params, amountBurning) => {
  const nextAmount = isNumber(amountBurning) ? amountBurning : 0
  if (params.amountBurning !== nextAmount) {
    props.onEngQuotaBurnUpdate({
      id: params.id,
      des: params.des,
      amountBurning: nextAmount,
    })
  }
}

const AmountBurningEditor = ({ params, props }) => {
  const [sign, setSign] = useState(params.amountBurning < 0 ? -1 : 1)
  const [value, setValue] = useState(Math.abs(params.amountBurning || 0))

  useEffect(() => {
    const nextSign = params.amountBurning < 0 ? -1 : 1
    const nextValue = Math.abs(params.amountBurning || 0)
    setSign(nextSign)
    setValue(nextValue)
  }, [params.amountBurning])

  const commitUpdate = nextValue => {
    const signedAmount = (isNumber(nextValue) ? nextValue : 0) * sign
    UpdateAmountInline(props, params, signedAmount)
  }

  return (
    <div className="amount-burn-input">
      <Radio.Group
        className="amount-sign-toggle"
        value={sign}
        onChange={e => {
          const nextSign = e.target.value
          setSign(nextSign)
          UpdateAmountInline(props, params, value * nextSign)
        }}
      >
        <Radio.Button value={1} className="amount-sign-positive">
          +
        </Radio.Button>
        <Radio.Button value={-1} className="amount-sign-negative">
          -
        </Radio.Button>
      </Radio.Group>
      <InputNumber
        style={{ width: "100%" }}
        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        value={value}
        width={100}
        min={0}
        onChange={nextValue => setValue(nextValue ?? 0)}
        onBlur={() => commitUpdate(value)}
      />
    </div>
  )
}

export const renderAmountButton = (params, { props }) => {
  return <AmountBurningEditor params={params} props={props} />
}

export const renderDesButton = (params, { props }) => {
  return (
    <Input.TextArea
      style={{ width: "100%" }}
      rows={1}
      defaultValue={params.des}
      width={100}
      onBlur={e => {
        UpdateInline(props, params, "des", e)
      }}
    />
  )
}

export const EngQuotaBurnColumnsAnt = props =>
  [
    {
      title: "سال",
      key: "year",
      render: params => params.quarterTariff.year,
      width: "3rem",
    },
    {
      title: "دوره",
      key: "period",
      render: params => params.quarterTariff.period,
      width: "3rem",
    },
    {
      title: "فصل",
      key: "period",
      render: params =>
        params.quarterTypeName + "-" + params.allotmentRoundTypeName,
      width: "7rem",
    },
    //fileNumber
    {
      title: "نام و نام خانوادگی",
      key: "k",
      render: params => params.engineer.fullName,
      width: "7rem",
    },
    {
      title: "مبلغ",
      key: "amountBurning",
      render: params => renderAmountButton(params, props),
      width: "8rem",
    },
    {
      title: "توضیحات",
      key: "amountBurning",
      render: params => renderDesButton(params, props),
      width: "10rem",
    },
    {
      title: "باقیمانده دوره قبل",
      key: "SumEngBalance",
      render: params => (
        <NumberFormat
          displayType={"text"}
          value={params.amountRemaining}
          thousandSeparator={true}
        />
      ),
      width: "7rem",
    },
    {
      title: "تایید",
      key: "payByBankReceipt",
      render: params => renderApprovedButton(params, props),
      width: "3rem",
    },
    // {
    //   title: "جمع کل واریزی",
    //   key: "SumEngBalance",
    //   render : params => <NumberFormat
    //   displayType={"text"}
    //   value={params.sumEngBalance}
    //   thousandSeparator={true}
    // />
    // },
    // {
    //   title: "جمع کل مانده",
    //   key: "SumEngBalance",
    //   render : params => <NumberFormat
    //   displayType={"text"}
    //   value={params.sumEngBalance- params.sumAmountEngRealWorkThisQuarter - params.sumAmountEngRealWorkBefore}
    //   thousandSeparator={true}
    // />
    // }
  ].filter(item => !item.hidden)
